export const calculateMaxRequests = (rps: number) => {
  const secondsInMinute = 60;
  const minutesInHour = 60;
  const hoursInDay = 24;
  const daysInMonth = 30;

  const secondsInMonth =
    secondsInMinute * minutesInHour * hoursInDay * daysInMonth;

  return rps * secondsInMonth;
};

export const numberToCurrencyNumber = (value: number) =>
  value.toLocaleString("ru-RU", {
    currency: "RUB",
    style: "currency",
  });

export const keyToString: Record<string, string> = {
  rps: "RPS",
  requests: "Кол-во запросов",
  withExport: "С выгрузками",
};

export const configValueToString = (value: number | boolean | null) => {
  if (typeof value === "number") {
    return value.toLocaleString("ru-RU");
  }

  if (typeof value === "boolean") {
    return value ? "Да" : "Нет";
  }

  if (value === null) {
    return "Безлимит";
  }
};
